// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Rj4M6","social":"Footer_social__tT5V2"};